import { render } from "./LoadingSpinnerBlue.vue?vue&type=template&id=85970906&scoped=true"
const script = {}

import "./LoadingSpinnerBlue.vue?vue&type=style&index=0&id=85970906&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85970906"]])

export default __exports__